import {
  Accordion,
  Container,
  Text,
  Title,
  rem,
  ThemeIcon,
} from "@mantine/core";
import { IconHelp } from "@tabler/icons-react"; // Make sure to install if not present, otherwise use existing icons
import { motion } from "framer-motion";
import { Colors, FrequentlyAskedQuestions } from "../../../Lib/Data";

export default function HomeFAQs() {
  return (
    <Container size="md" py={80} id="faq">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        <div style={{ textAlign: "center", marginBottom: 50 }}>
          <ThemeIcon
            size={50}
            radius="xl"
            variant="light"
            color="green"
            style={{ marginBottom: 20 }}
          >
            <IconHelp style={{ width: rem(30), height: rem(30) }} />
          </ThemeIcon>
          <Title
            order={2}
            style={{
              fontSize: rem(36),
              fontWeight: 800,
              color: Colors.GreenSecondary,
              lineHeight: 1.2,
            }}
          >
            Frequently Asked Questions
          </Title>
          <Text c="dimmed" mt="md" size="lg" maw={600} mx="auto">
            Everything you need to know about the product and billing. Can’t
            find the answer you’re looking for? Please contact our support.
          </Text>
        </div>

        <Accordion
          variant="separated"
          radius="md"
          chevronPosition="right"
          styles={{
            item: {
              border: "1px solid var(--mantine-color-gray-3)",
              backgroundColor: "var(--mantine-color-white)",
              marginBottom: 15,
            },
            control: {
              padding: "16px 20px",
            },
            label: {
              fontWeight: 600,
              fontSize: rem(16),
            },
            content: {
              padding: "0 20px 20px 20px",
              lineHeight: 1.6,
              color: "var(--mantine-color-gray-7)",
            },
          }}
        >
          {FrequentlyAskedQuestions.filter((f) => f.hidden !== true).map(
            (question) => (
              <Accordion.Item key={question.value} value={question.value}>
                <Accordion.Control>{question.value}</Accordion.Control>
                <Accordion.Panel>{question.description}</Accordion.Panel>
              </Accordion.Item>
            )
          )}
        </Accordion>
      </motion.div>
    </Container>
  );
}
